import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DescriptionIcon from '@material-ui/icons/Description';
import {setUpdateButtonActiveStepToTrue, updateCounter} from '../../../../store/actions/main';
import {selectUploadDataPforte,
        updateDescriptionPforte,
        updateStepsPforte,
        updateProductToMerklistePforte,
        updateAllVisitedStepsPforte
        } from '../../../../store/actions/pforten';
import {Link} from 'react-router-dom';
import LaunchIcon from '@material-ui/icons/Launch';
//import {PrintAngebot} from '../../../../module/printAngebot';


const Step_7 = props => {
    const [is_upload_data, updateUploadData] = useState('');
    const [validFile, updateValidFile] = useState(true);
    const [mbytes, updateMbytes] = useState(0);
    const [fileName, updateFileName] = useState('');
    const [descriptionData, updateDescriptionData] = useState('');
    let [is_merkliste, isMerklisteUpdate] = useState(false);
    let empty_file = '';
    // let [printMainTitel, setPrintMainTitel] = useState('');
    // let [printMuster, setPrintMuster] = useState('');
    // let [isMuster, setIsMuster] = useState(false);
    // let [printDimensions, setPrintDimensions] = useState('');
    // let [printColors, setPrintColors] = useState('');
    // let [printSpitzen, setPrintSpitzen] = useState('');
    // let [printPfosten, setPrintPfosten] = useState('');
    // let [printDirection, setPrintDirection] = useState('');
    // let [printPrice, setPrintPrice] = useState(0);

    useEffect(() => {
        updateItems();
    })

    const updateItems = () => {
        const {isUploadData, description, file} = props.data.data_description[0];
        let is_merkliste = props.data.is_merkliste;
        let data_upload_button = document.querySelector('.data_upload_button');
        let addButtonMerkliste = document.querySelector('.addButtonMerkliste');
        let toWishListButton = document.querySelector('.toWishListButton');

        if (isUploadData) {
            data_upload_button.classList.add('check');
        } else {
            data_upload_button.classList.remove('check');
        }

        updateUploadData(isUploadData);
        updateDescriptionData(description);
        isMerklisteUpdate(is_merkliste);

        if (file) {
            updateFileName(file.name);
            const bytesToMegaBytes = file.size / (1024 ** 2);
            updateMbytes(bytesToMegaBytes);
        }

        if (is_merkliste) {
            addButtonMerkliste.classList.add('check');
            toWishListButton.classList.add('check');
        } else {
            addButtonMerkliste.classList.remove('check');
            toWishListButton.classList.remove('check');
        }

        //update steps
        props.updateSteps(6);

        props.setUpdateButtonActiveStepToTrue();
        props.updateAllVisitedStepsPforte();
        //printItems();
    }

    // const printItems = () => {
    //     let mainTitel = props.data.modell[0].muster === 'Sortiment'&&props.data.modell[0].titel?props.data.modell[0].titel:'Eigenes Muster';
    //     if (mainTitel === 'Eigenes Muster') setIsMuster(false);
    //     else setIsMuster(true);
    //     let muster = props.data.modell[0].img;
    //     let dimensions = props.data.dimensions[0];
    //     let colors = props.data.colors[0];
    //     let spitzen = props.data.spitzen[0].spitze;
    //     let pfosten = props.data.pfosten[0];
    //     let direction = props.data.direction;
    //     let price = props.data.modell[0].price;

    //     setPrintMainTitel(mainTitel);
    //     setPrintMuster(muster);
    //     setPrintDimensions(dimensions);
    //     setPrintColors(colors);
    //     setPrintSpitzen(spitzen);
    //     setPrintPfosten(pfosten);
    //     setPrintDirection(direction);
    //     setPrintPrice(price);
    // }


    const selectUploadData = ev => {
        ev.preventDefault();
        let file = ev.target.files[0];
        console.log('FILE', file);

        const fileSize = file.size;
        const bytesToMegaBytes = fileSize / (1024 ** 2);

        if (bytesToMegaBytes > 5) {
            updateValidFile(false);
        } else {
            updateValidFile(true);
            updateMbytes(bytesToMegaBytes);
            updateFileName(file.name);
        }

        let uploadObject = {
            file: file
         }

         props.selectUploadData(uploadObject);
         updateItems();

    }

    const updateDescription = ev => {
        let description = ev.target.value;
        props.updateDescription(description);
        updateItems();
    }

    const updateProductToMerkliste = () => {
        props.updateProductToMerklist();
        updateItems();
       if(is_merkliste) props.updateCounter('dec');
       else  props.updateCounter('inc');
   }


    return (
        <div className="step_wrapper">
            <h2 className='step_header'>Hier können Sie uns Ihr Anliegen mit einer detalierten Beschreibung und ggf. einer Skizze mitteilen.</h2>
            <div className="step_icon_wrapper">
                <TextField
                    className="outlined-multiline-static textfield_multiline"
                    type="text"
                    label="Ihr Anliegen:"
                    rowsMax={10}
                    multiline
                    variant="outlined"
                    value={descriptionData}
                    name="description"
                    onChange={updateDescription}
                    >
                </TextField>
                <div className="merkliste_button_wrapper">
                    <Button  className='data_upload_button' component="label" startIcon={<DescriptionIcon />}>
                        {is_upload_data?
                        <span>Datei ausgewählt<br/>({fileName.substring(0, 14)+'...'} {mbytes.toFixed(2)} MB)</span>
                        :
                        <span>Datei auswählen<br/>(max 5MB)</span>
                        }
                        <input id='myfileinput' name='productimage' className='upload_file_zaun' type="file" onChange={selectUploadData} value={empty_file} hidden />
                    </Button>
                    {!validFile && <span style={{color:'red', margin:'10px 0'}}>Ihre Datei ist zu groß für das Zieldateisystem</span>}
                    {/* <PrintAngebot
                        product='Pforte'
                        mainTitel={printMainTitel}
                        muster={printMuster}
                        isMuster={isMuster}
                        dimensions={printDimensions}
                        colors={printColors}
                        spitzen={printSpitzen}
                        pfosten={printPfosten}
                        direction={printDirection}
                        price={printPrice}
                        className='print_button'
                    /> */}
                    <Button className='addButtonMerkliste' onClick={updateProductToMerkliste}>{is_merkliste?'aus der Merkliste entfernen':'in die Merkliste hinzufügen'}</Button>
                    <Link className="link" to={is_merkliste?'/merkliste':'#'}><Button className='toWishListButton'>Zur Merkliste <LaunchIcon className='launch-icon' /></Button></Link>
                </div>

            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
      data: state.pfortenReducer.data
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
        updateCounter: ev => dispatch(updateCounter(ev)),
        selectUploadData: ev => dispatch(selectUploadDataPforte(ev)),
        updateDescription: ev => dispatch(updateDescriptionPforte(ev)),
        updateSteps: ev => dispatch(updateStepsPforte(ev)),
        updateProductToMerklist: () => dispatch(updateProductToMerklistePforte()),
        updateAllVisitedStepsPforte: () => dispatch(updateAllVisitedStepsPforte())
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_7);

